// Organization y WebSite del sitio: una sola definición, con @id fijo, para todas las
// páginas que los declaran. Así el home y el SERP describen la misma entidad.

// Se omite todo campo sin dato (regla de la auditoría SEO: nunca placeholders).
export const sinVacios = obj =>
	Object.fromEntries(
		Object.entries(obj).filter(
			([, v]) => v !== null && v !== undefined && v !== "" && !(Array.isArray(v) && v.length === 0)
		)
	);

type ConfigSitio = {
	main_domain?: string;
	country_code?: string;
	site_name?: string;
	logo?: string;
	information_email?: string;
	socialMediaLinks?: { url?: string }[];
};

const urlSitio = (main_domain?: string) => "https://" + main_domain;

const idOrganizacion = (main_domain?: string) => urlSitio(main_domain) + "/#organization";

// La búsqueda por texto de IC2 (?searchstring=) cuelga del listado de la operación por
// defecto. Casas en el Este no tiene /venta: su búsqueda es la de alquiler temporal.
const rutaBusqueda = (country_code?: string) => (country_code === "ce3" ? "/alquiler-temporal" : "/venta");

// Sin teléfono: el de la configuración de Colombia es el número de Uruguay, y publicarlo
// lo declararía como contacto de Fincaraíz.
export const organizacionJson = ({ main_domain, site_name, logo, information_email, socialMediaLinks }: ConfigSitio) =>
	sinVacios({
		"@type": "Organization",
		"@id": idOrganizacion(main_domain),
		"name": site_name,
		"url": urlSitio(main_domain),
		"logo": logo,
		// Las redes del «Síguenos» del footer, que también saltea las que no tienen URL.
		"sameAs": socialMediaLinks?.map(i => i?.url).filter(Boolean),
		"email": information_email,
	});

export const sitioWebJson = (config: ConfigSitio, publisher: object = organizacionJson(config)) =>
	sinVacios({
		"@type": "WebSite",
		"@id": urlSitio(config.main_domain) + "/#website",
		"name": config.site_name,
		"url": urlSitio(config.main_domain),
		"publisher": publisher,
	});

// El home declara la Organization una vez y el WebSite la referencia por @id.
export const homeJsonLd = (config: ConfigSitio) => ({
	"@context": "https://schema.org",
	"@graph": [
		organizacionJson(config),
		{
			...sitioWebJson(config, { "@id": idOrganizacion(config.main_domain) }),
			"potentialAction": {
				"@type": "SearchAction",
				"target": {
					"@type": "EntryPoint",
					"urlTemplate":
						urlSitio(config.main_domain) + rutaBusqueda(config.country_code) + "?searchstring={search_term_string}",
				},
				"query-input": "required name=search_term_string",
			},
		},
	],
});
